import { Keys } from 'src/i18n';
import {
  KEY_METRICS_DETAILS,
  KEY_METRICS_TITLE,
  PERFORMANCE_DASHBOARD,
  PERFORMANCE_SNAPSHOT,
  PERFORMANCE_WIDGET,
} from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import Dashboard from '.';
import KeyMetricsWebTitle from './keyMetrics/components/webTitle';
import KeyMetricsDetails from './keyMetrics/details';
import KeyMetricsDetailsThunk from './keyMetrics/thunk';
import PerformanceSnapshot from './snapshot';
import PerformanceSnapshotThunk from './snapshot/thunk';
import DashboardThunk from './thunk';
import PerformanceWidget from './widget';
import PerformanceWidgetThunk from './widget/thunk';

const module: ModulesList = {
  [PERFORMANCE_DASHBOARD]: {
    path: '/performance/:tab',
    component: Dashboard,
    thunk: DashboardThunk,
  } as Module,

  [PERFORMANCE_SNAPSHOT]: {
    component: PerformanceSnapshot,
    thunk: PerformanceSnapshotThunk,
  } as Module,

  [PERFORMANCE_WIDGET]: {
    component: PerformanceWidget,
    thunk: PerformanceWidgetThunk,
  },

  [KEY_METRICS_DETAILS]: {
    path: '/performance/key_metrics/:id',
    hostApp: {
      hideSideHamBurgerMenu: true,
    },
    component: KeyMetricsDetails,
    thunk: KeyMetricsDetailsThunk,
    breadCrumbs: {
      design: 'modern',
      titleComponent: KEY_METRICS_TITLE,
      items: [
        {
          path: `#/performance/key_metrics`,
          legacy: true,
          breadcrumbName: {
            localeKey: Keys.KEY_METRICS,
          },
        },
        {
          path: `#/performance/key_metrics/:id`,
          legacy: true,
          breadcrumbName: {
            routeParamKey: 'keyMetricName',
          },
        },
      ],
    },
  } as Module,
  [KEY_METRICS_TITLE]: {
    component: KeyMetricsWebTitle,
  },
};

export default module;
